import React, { useState } from 'react'
import styled from '@emotion/styled'
import WhatsAppIcon from './images/whatsapp-icon'

const WhatsappButton = styled.button`
  position:fixed;
  height:39px;
  bottom: 52px;
  right:40px;
  background-color:transparent;
  color:#FFF;
  border-radius:50px;
  text-align:center;
  font-size:30px;
  z-index:100;
  padding: 0px;
  border: 0px solid #ffff;
  cursor: pointer;

  @media (max-width: 450px) {
    bottom: 30px;
    right: 10px;
  }
`
  

const TextHelp = styled.p`
  color: #4AC959;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
  width: 266px;

  @media (max-width: 450px) {
    font-size: 13px;
    width: 300px;
  }

  @media (max-width: 350px) {
    width: 170px;
    font-size: 15px;
  }
`
 
const ContentHelp = styled.div`
  position: fixed;
  bottom: 30px;
  right: 60px;
  background: #fff;
  color: #525050;
  padding: 15px;
  border-radius: 27.947px;
  width: 363px;
  height: 51px;
  border: 1.03px solid #4AC959;
  padding: 15px 29px;

  @media (max-width: 450px) {
    bottom: 15px;
    right: 13px;
    padding: 16px 11px;
    width: 355px;
  }
  @media (max-width: 350px) {
    width: 280px;
    padding: 8px 30px;
  }
`

const WhatsAppButton = () => {
  const [showMessage, setShowMessage] = useState(false)
  
  const phoneNumber = '56225926600'

  const openWhatsAppChat = () => {
    const whatsappLink = `https://capitaria.trb.ai/wa/1u9FWot`
    window.open(whatsappLink, '_blank')
  }

  const handleMouseEnter = () => {
    setShowMessage(true)
  }

  const handleMouseLeave = () => {
    setShowMessage(false)
  }

  return (
    <div>
      <WhatsappButton 
        onClick={openWhatsAppChat}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <WhatsAppIcon/>
      </WhatsappButton>
      {showMessage && (
        <ContentHelp>
          <TextHelp>¡Hola! Cuéntanos, ¿cómo te podemos ayudar? 😃</TextHelp>
        </ContentHelp>
      )}
    </div>
  )
}

export default WhatsAppButton
